import React from 'react';
import { Button } from 'primereact/button';
import { PrimeIcons } from 'primereact/api';
import { classNames } from 'primereact/utils';
import BusinessHoursSection from '../../../components/BusinessHoursSection/BusinessHoursSection';
import { FormField } from '../../../components/FormField/FormField';
import { HolidaysList } from '../../../components/HolidaysList/HolidaysList';
import { ReservationTypeWithColor } from '../../../hooks/AppData/useReservationTypes';
import { Branch } from '../../../types/branch';
import { ReservationHoursFormState } from '../hooks/useReservationHoursForm';

interface Props {
  reservationHours: ReservationHoursFormState;
  reservationTypesWithRestrictedDates: ReservationTypeWithColor[] | undefined;
  orgBranches: Branch[] | undefined;
  selectedBranchId: string | undefined;
  organizationLoading: boolean;
  userHasEditFeature: boolean;
  onOpenCopyHoursDialog: (e: React.MouseEvent) => void;
  onOpenHolidaysDialog: (reservationType: ReservationTypeWithColor) => void;
}

export const ReservationHoursSection = ({
  reservationHours,
  reservationTypesWithRestrictedDates,
  orgBranches,
  selectedBranchId,
  organizationLoading,
  userHasEditFeature,
  onOpenCopyHoursDialog,
  onOpenHolidaysDialog,
}: Props) => {
  return (
    <form
      className={classNames({
        'form-loading': organizationLoading || reservationHours.isSaving,
      })}
      onSubmit={reservationHours.handleSave}
      ref={reservationHours.formRef}
    >
      <FormField fullWidth>
        <div className='reservation-hours-header'>
          <h4 className='reservation-hours-title'>Horarios de reservas</h4>
          {userHasEditFeature && orgBranches && orgBranches.length > 1 && selectedBranchId && (
            <Button
              icon={PrimeIcons.COPY}
              label='Copiar horarios'
              onClick={onOpenCopyHoursDialog}
              className='copy-hours-button'
              text
              severity='secondary'
            />
          )}
        </div>
      </FormField>
      {reservationTypesWithRestrictedDates?.map((reservationType) => (
        <FormField
          className={classNames({ 'full-width': reservationTypesWithRestrictedDates.length === 1 })}
          key={reservationType.id}
        >
          <BusinessHoursSection
            onChange={(value) =>
              reservationHours.setFormFields({
                [reservationType.id]: {
                  ...reservationHours.form?.[reservationType.id],
                  hours: value,
                },
              })
            }
            value={reservationHours.form?.[reservationType.id]?.hours}
            title={reservationType.name ?? 'individuales'}
            isEditable={userHasEditFeature}
          />
          <FormField fullWidth>
            <h4 className='closed-days-title'>Días de cierre</h4>
          </FormField>
          <FormField fullWidth>
            {userHasEditFeature && (
              <Button
                type='button'
                text
                className='holidays-selector-button'
                onClick={() => onOpenHolidaysDialog(reservationType)}
                icon='pi pi-calendar'
                label='Seleccionar días de cierre'
              />
            )}
            <HolidaysList
              holidays={reservationHours.form?.[reservationType.id]?.closedDays ?? []}
              onRemove={(date) => reservationHours.handleRemoveHoliday(reservationType, date)}
              isEditable={userHasEditFeature}
              showPastDates={false}
            />
          </FormField>
        </FormField>
      ))}
      {userHasEditFeature && (
        <Button
          type='submit'
          disabled={!reservationHours.hasChanged}
          className='pull-right pull-down'
          label='Guardar'
          icon={PrimeIcons.SAVE}
        />
      )}
    </form>
  );
};
